import { isRouteErrorResponse, useNavigate, useRouteError } from 'react-router'

import { Button } from '@/components/ui/Button'
import { ErrorState } from '@/components/feedback/States'

/**
 * Fanger fejl kastet under rendering af en rute, så en enkelt ødelagt side
 * ikke efterlader brugeren med en tom skærm.
 */
export function RouteErrorBoundary() {
  const error = useRouteError()
  const navigate = useNavigate()

  const message = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : 'Der opstod en uventet fejl.'

  return (
    <div className="flex min-h-dvh items-center justify-center p-6">
      <div className="surface-panel w-full max-w-lg">
        <ErrorState
          error={new Error(message)}
          title="Noget gik galt"
          // Genindlæsning er den eneste pålidelige måde at komme videre på,
          // når komponenttræet allerede er i en ugyldig tilstand.
          onRetry={() => window.location.reload()}
        />
        <div className="flex justify-center pb-6">
          <Button variant="ghost" size="sm" onClick={() => void navigate('/app/dashboard')}>
            Til overblik
          </Button>
        </div>
      </div>
    </div>
  )
}
